import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import { useRealtimePollInterval } from '../../../realtime/useRealtimePollInterval';
import type { OutreachCampaignLive } from '../outreachTypes';
import { useRetry } from './useRetry';

/** The poll of a working campaign while the socket is down (owner rule: no poll with the socket up). */
const LIVE_POLL_MS = 15000;

/**
 * `outreach.campaigns.live` (design t1, t2). The realtime events read it again
 * (`useOutreachRealtime`); it polls only while the socket is down.
 */
export function useCampaignLive(accountId: number, campaignUuid: string) {
  const trpcAPI = useTRPCAPI();
  const refetchInterval = useRealtimePollInterval(LIVE_POLL_MS);
  const query = useTRPCQuery(
    trpcAPI.outreach.campaigns.live.queryOptions(
      { accountId, campaignUuid },
      {
        retry: false,
        refetchInterval: (state: { state: { data: unknown } }) => {
          const phase = (state.state.data as OutreachCampaignLive | null | undefined)?.phase;
          if (phase === 'done' || phase === 'draft' || refetchInterval <= 0) {
            return false;
          }
          return refetchInterval;
        },
      }
    )
  );
  const retry = useRetry(query.refetch);
  return {
    live: (query.data ?? undefined) as OutreachCampaignLive | undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
